// Utils/Auth.js
export const getToken = () => {
  return sessionStorage.getItem('authToken')
}

export const isAuthenticated = () => {
  return !!getToken()
}

export const logout = () => {
  sessionStorage.clear()
}
